import React from 'react';
import {Dimensions, Text, View} from 'react-native';
import {BREAKPOINT} from '../../../data/constants/screen';
import {GlossStyles} from './styles';

type Props = {
  word: string;
  definition: string;
  title?: string;
};

export function GlossaireComponent({word, definition, title}: Props) {
  return (
    <View
      style={[
        GlossStyles.container,
        {
          paddingHorizontal:
            Dimensions.get('window').width > BREAKPOINT.sm ? 100 : 30,
        },
      ]}>
      <Text style={GlossStyles.pageTtl}>{title}</Text>
      <Text style={GlossStyles.titre}>{word}</Text>
      <Text style={GlossStyles.definition}>{definition}</Text>
    </View>
  );
}
